import { NgModule } from '@angular/core';
import { ConfirmationAlertDirective } from './confirmation-alert/confirmation-alert.directive';
import { UseUtcDirectiveDirective } from './use-utc-directive/use-utc-directive.directive';
import { TabviewArrowsStateDirective } from './tabview-arrows-state/tabview-arrows-state.directive';

const directives = [
  ConfirmationAlertDirective,
  UseUtcDirectiveDirective,
  TabviewArrowsStateDirective
]

@NgModule({
  declarations: [
    ...directives,
    ],
  exports: [
    ...directives]
 
})
export class DirectivesModule { }